import { getFontColorClassName } from '@components/app/TrialAwardBadges/getFontColorClassName'
import { getIcon } from '@components/app/TrialAwardBadges/getIcon'
import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import type { ArrayElement } from '@lib/types/arrayElement'
import type { TrialAwardBadgeLabel } from '@modules/trials/etl/ingestTrial2024/handleTrialAwardBadges/types'
import type { TrialInAlgolia } from '@modules/trials/types/TrialInAlgolia'

export const getAwardBadgeDisplay = (
  awardBadge: ArrayElement<TrialInAlgolia['awardBadges']>,
) => {
  const fontColorClassName = getFontColorClassName(awardBadge.tags ?? [])
  const icon = getIcon(
    awardBadge.label as TrialAwardBadgeLabel,
    awardBadge.tags ?? [],
  )
  return { fontColorClassName, icon }
}

const AwardBadgeCard = ({
  awardBadge,
  iconClassName,
}: {
  awardBadge: ArrayElement<TrialInAlgolia['awardBadges']>
  iconClassName?: string
}) => {
  const { fontColorClassName, icon } = getAwardBadgeDisplay(awardBadge)
  return (
    <div
      className='w-full rounded-xl border border-neutral200 bg-white p-6'
      key={awardBadge.id}
    >
      <div className='flex flex-row items-center'>
        <div className={iconClassName}>
          <Icon
            className={classMerge('mr-2 inline-block', fontColorClassName)}
            icon={icon}
            size='lg'
          />
        </div>
        <Text
          className='text-neutral900'
          styleName={'p-strong'}
          value={awardBadge.name}
        />
      </div>
      <div className='pt-1'>
        <Text
          className='text-neutral600'
          styleName='p'
          value={awardBadge.whyThisMatters}
        />
      </div>
    </div>
  )
}

export const AwardBadgeCards = ({
  awardBadges,
  iconClassName = '',
}: {
  awardBadges: TrialInAlgolia['awardBadges']
  iconClassName?: string
}) => {
  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
      {awardBadges.map((awardBadge) => (
        <AwardBadgeCard
          awardBadge={awardBadge}
          iconClassName={iconClassName}
          key={awardBadge.id}
        />
      ))}
    </div>
  )
}
